
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SearchSummaryAvailabilitySearch extends Vue {
  @Prop()
  count: number

  @Prop()
  bookableCount: number

  @Prop()
  distance: object

  @Prop()
  searchPlace: string

  @Prop()
  hierarchyName: string

  @Prop()
  categoryName: string

  @Prop()
  isUserLocationSearch: boolean
}
